import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const FlashIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 26"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M10.3269 14.2083H4.75L8.09615 1H15.9038L13.6731 9.76389H19.25L8.09615 24.875L10.3269 14.2083Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
  </Svg>
);

FlashIcon.displayName = 'FlashIcon';
